import { Translation } from '../../../settings/i18n/languages';

export const pl: Translation = {
  //ogólne
  YES: 'Tak',
  NO: 'Nie',
  ID: 'Id',
  LP: 'Lp.',
  OF: 'z',
  TO: 'na',
  BY: 'przez',
  EMPTY_IS_NOT_ALLOWED: 'Pole wymagane',
  NATURAL_NUMBERS_ALLOWED: 'Dozwolone liczby naturalne',
  ARE_YOU_SURE: 'Czy jesteś pewien?',
  SAVE_CHANGES: 'Zapisz zmiany',
  CONFIRM: 'Potwierdź',
  CANCEL: 'Anuluj',
  CLOSE: 'Zamknij',
  AND: 'i',
  ON_BEHALF_OF: 'w imieniu',
  NO_DATA: 'Brak danych',
  NO_MARK: 'Brak',
  START_TYPING: 'Rozpocznij wpisywanie, aby wyszukać',
  START_TYPING_SHORT: 'Wyszukaj',
  EXPAND: 'Rozwiń',
  COLLAPSE: 'Zwiń',
  BUTTON_NEXT: 'Następny',
  BUTTON_PREV: 'Poprzedni',
  SEMESTRAKADEMICKI_ZIMA: 'Zima',
  SEMESTRAKADEMICKI_LATO: 'Lato',
  CLOSE_TAB: 'Zamknij zakładkę',
  CLICK_HERE: 'kliknij tutaj',
  PRINT_STUDENTS_LIST: 'Drukuj listę studentów',
  PRINT_STUDENTS_LIST_WITH_MARKS: 'Drukuj listę ocen',
  PRINT_ATTENDANCE_LIST: 'Drukuj listę obecności',
  GET_ALL_RECORDS: 'Pobierz wszystkie rekordy',
  GET_STUDENTS_LIST_EXCEL: 'Eksportuj do pliku .csv',

  EXPIRED_REFRESH_TOKEN_ERROR_TITLE: 'Sesja wygasła',
  EXPIRED_REFRESH_TOKEN_REDIRECT_TO_CAS: 'Zostaniesz przekierowany do serwisu uwierzytelniającego',

  TEACHER_SESSION_ACTIVE_CANNOT_LOGIN: 'Brak dostępu do zasobu',
  COLUMNS_FILTER_MODAL_SELECT_MIN_ONE_ERROR: 'Wybierz minimum jedną kolumnę z każdej listy',
  UNKNOWED_ERROR_TITLE: 'Wystąpił nieznany błąd',
  UNKNOWED_ERROR_BODY: 'Spróbuj ponownie później',
  WRONG_CODE_TITLE: 'Niepoprawny kod!',
  WRONG_EMAIL_CODE_BODY: 'Wpisany kod email jest nieprawidłowy. Spróbuj ponownie',
  WRONG_SMS_CODE_BODY: 'Wpisany kod sms jest nieprawidłowy. Spróbuj ponownie',

  ERROR_PROTOCOL_GENERATION_NO_SUM_CONTROL_TITLE: 'Błąd zapisu protokołu do bazy',
  ERROR_PROTOCOL_GENERATION_NO_SUM_CONTROL_BODY:
    'Wystąpił błąd zapisu protokołu do bazy przez brak sumy kontrolnej, skontaktuj się z administratorem systemu',

  CHANGE_LANGUAGE: 'Zmień język',
  WRONG_DATA_FORMAT_INFO: 'Niepoprawny format danych',
  NO_GRADES_IMPORTANCE: 'Wagi form zajęć nie zostały uzupełnione, wystawienie niektórych ocen cząstkowych nie jest możliwe',
  NO_GRADES_IMPORTANCE_TITLE:
    'Brak wag do form zajęć. Nie można wystawić niektórych ocen cząstkowych lub ocena końcowa nie zostanie wyliczona.',
  FORMA_NO_GRADES_IMPORTANCE: 'Dla tej formy nie można wystawić oceny cząstkowej. Waga formy nie została uzupełniona.',
  NO_FORMY_ZAJEC_TITLE: 'Brak form zajęć dla tego przedmiotu',
  NO_FORMY_ZAJEC_DESCRIPTION: 'Skontaktuj się z kierownikiem karty lub dziekanatem w celu uzupełnienia form zajęć.',
  NO_RIGHTS_TO_GIVE_MARK: 'Nie masz uprawnień do wpisania tej oceny',
  NO_PARTIAL_MARKS: 'Brak form zajęć',
  ROLE_SUPERTEACHER: 'Supernauczyciel',
  ROLE_SUBJECT_MANAGER: 'Kierownik przedmiotu',
  ROLE_INSTRUCTOR: 'Wykładowca',
  MY_SUBJECTS_TAB_TITLE: 'Moje przedmioty',
  STUDENTS_TAB_TITLE: 'Studenci',
  SUBJECT_CARDS_TAB_TITLE: 'Karty przedmiotów',
  STUDENT_FINDER_TAB_TITLE: 'Studenci',
  TABLE_HEADER_TOTAL: 'Liczba rekordów',
  TABLE_HEADER_DISPLAYED: 'Wyświetlono',
  TABLE_HEADER_SELECTED: 'Zaznaczono',
  TABLE_HEADER_REMAINDER: 'Pozostałe',
  FILTER_ADD_FILTER: 'Dodaj filtr',
  FILTER_SEMESTER: 'Semestr',
  FILTER_YEAR: 'Rok akademicki',
  FILTER_SUBJECT: 'Przedmiot',
  FILTER_NO_FITLERS: 'Brak dostępnych filtrów',
  COLUMNS_FILTER_MAIN_TITLE: 'Dane ogólne',
  COLUMNS_FILTER_MAIN_SUBTITLE: 'Dane widoczne w kolumnach tabeli',
  COLUMNS_FILTER_DETAILS_TITLE: 'Dane szczegółowe',
  COLUMNS_FILTER_DETAILS_SUBTITLE: 'Dane widoczne po wybraniu elementu z listy',
  BUTTON_GENERATE_PROTOCOL: 'Generuj Protokół',
  BUTTON_CHANGE_LOG: 'Historia Zmian',
  BUTTON_SIGN_MARKS: 'Podpisz oceny',
  BUTTON_GO_TO_STUDENT_TAB: 'Pokaż studenta',
  // 'BUTTON_COPY_FINAL_MARKS': 'Przepisz oceny końcowe z ocen wyliczonych',
  BUTTON_COPY_FINAL_MARKS: 'Wystaw oceny końcowe',
  BUTTON_EDIT_FINAL_MARK: 'Edytuj Ocenę Końcową',
  USER_PANEL_SETTINGS: 'Ustawienia',
  USER_PANEL_HELP: 'Pomoc',
  USER_PANEL_LOGOUT: 'Wyloguj',
  USER_PANEL_LOGIN: 'Zaloguj',
  SUPERTEACHER_PANEL_NAME: 'Panel supernauczyciela',
  SUPERTEACHER_PANEL_LOGOUT_FROM: 'Powrót do głównego konta',
  SUPERTEACHER_PANEL_LOGIN_AS: 'Zaloguj jako...',
  IN_PROGRESS_GENERATE_PROTOCOL: 'W trakcie generowania..',

  //przydział
  PRZYDZIAL_LIST_PROWADZACYPID: 'Id prowadzącego',
  PRZYDZIAL_LIST_ROKAKADEMICKI: 'Rok akademicki',
  PRZYDZIAL_LIST_SEMESTRAKADEMICKI: 'Semestr akademicki',
  PRZYDZIAL_LIST_PRZEDMIOTFORMAKOD: 'Forma zajęć',
  PRZYDZIAL_LIST_PRZEDMIOTFORMANAZWA: 'Nazwa przedmiotu',
  PRZYDZIAL_LIST_PRZEDMIOTFORMAKODLISTA: 'Kod przedmiotu',
  PRZYDZIAL_LIST_PROWADZACYPIDLISTA: 'Lista Id prowadzących',
  PRZYDZIAL_LIST_PROWADZACYNAZWALISTA: 'Prowadzący',
  PRZYDZIAL_LIST_PRZEDMIOTFORMANAZWALISTA: 'Formy przedmiotów',

  PRZYDZIAL_PRZEDMIOTID: 'Id przedmiotu',
  // 'PRZYDZIAL_POWADZACYPID': 'Id prowadzącego',
  PRZYDZIAL_PRZEDMIOTKOD: 'Kod przedmiotu',
  PRZYDZIAL_PRZEDMIOTFORMAKOD: 'Kod formy przedmiotu',
  PRZYDZIAL_PRZEDMIOTFORMANAZWA: 'Forma Przedmiotu',
  PRZYDZIAL_PRZEDMIOTFORMAKODLISTA: 'Kody form zajęć',
  PRZYDZIAL_PRZEDMIOTFORMANAZWALISTA: 'Formy zajęć',
  PRZYDZIAL_PROWADZACYPIDLISTA: 'Id prowadzących',
  PRZYDZIAL_PROWADZACYNAZWALISTA: 'Prowadzący',
  PRZYDZIAL_WAGAFORMYZAJEC: 'Waga ocen',
  PRZYDZIAL_WAGIFORMYZAJEC: 'Wagi form zajęć',
  PRZYDZIAL_ROKAKADEMICKI: 'Rok akademicki',
  PRZYDZIAL_LICZBASTUDENTOW: 'Liczba studentów',
  PRZYDZIAL_WYDZIALZLECAJACYNAZWA: 'Wydział zlecający',
  PRZYDZIAL_PROWADZACYPID: 'Id prowadzącego',
  PRZYDZIAL_PRZEDMIOTNAZWA: 'Nazwa przedmiotu',
  PRZYDZIAL_SEMESTRAKADEMICKI: 'Semestr akademicki',
  PRZYDZIAL_WYDZIALZLECAJACYKOD: 'Kod wydziału zlecającego',
  PRZYDZIAL_OCENAKONCOWA: 'Ocena końcowa',
  KIEROWNICY_KARTY_LISTA: 'Kierownik karty',
  PRZYDZIAL_INFO_YOUAREMANAGER: 'Jesteś kierownikiem tego przedmiotu',
  PRZYDZIAL_BRAK_PRZYDZIALU_SID_TITLE: 'Dla tego przedmiotu nie został utworzony przydział',
  PRZYDZIAL_BRAK_PRZYDZIALU_SID_DESCRIPTION: 'Aby wystawić oceny należy najpierw utworzyć przydział.',
  CZY_PROTOKOL_AKTUALNY: 'Aktualny protokół',

  // Studenci
  STUDENT_PRACOWNIKID: 'Id użytkownika',
  STUDENT_SEMESTRAKADEMICKI: 'Semestr',
  STUDENT_ROKAKADEMICKI: 'Rok',
  STUDENT_STUDENTID: 'Id studenta',
  STUDENT_STUDENTALBUM: 'Nr albumu',
  STUDENT_STUDENTIMIE: 'Imię',
  STUDENT_STUDENTNAZWISKO: 'Nazwisko',
  STUDENT_STUDENTZDJECIE: 'Zdjęcie',
  STUDENT_STUDENTWYDZIAL: 'Wydział studenta',
  STUDENT_KIERUNEKID: 'Id kierunku studiów',
  STUDENT_KARTAOCENID: 'Id karty Ocen',
  STUDENT_KARTATYP: 'Typ Karty Ocen',
  STUDENT_KIERUNEKNAZWA: 'Kierunek Studiów',
  STUDENT_RODZAJSTUDIOW: 'Rodzaj studiów',
  STUDENT_SEMESTRSTUDIOW: 'Semestr studiów',
  STUDENT_OCENAKONCOWA: 'Ocena końcowa',
  STUDENT_OCENAWYLICZONA: 'Ocena wyliczona',
  STUDENT_CZYOCENAKONCOWAPODPISANA: 'Podpisano ocenę',
  STUDENT_FORMYZAJEC: 'Formy zajęć',
  STUDENT_PRZEDMIOTID: 'Id przedmiotu',
  STUDENT_PRZEDMIOTKOD: 'Kod przedmiotu',
  STUDENT_PRZEDMIOTDATA: 'Data wystawienia',
  STUDENT_CZYOCENARECZNA: 'Ocena wystawiona ręcznie',
  GRUPA_DZIEKANSKA: 'Grupa dziekańska',
  ACTIVITY_NUMBER: 'Numer zajęć',
  ATTENDANCE_LIST: 'Lista obecności',
  STUDENTS_LIST: 'Lista studentów',
  STUDENTS_LIST_WITH_MARKS: 'Lista ocen',

  // Karty przedmiotów
  PRZEDMIOT_ID: 'Id przedmiotu',
  PRZEDMIOT_KOD: 'Kod przedmiotu',
  PRZEDMIOT_NAZWA: 'Nazwa przedmiotu',
  PRZEDMIOT_NAZWA_DLUGA: 'Pełna nazwa przedmiotu',
  KIEROWNIK_PRZEDMIOTU_ID: 'Id kierownika przedmiotu',
  KIERUNEK_NAZWA: 'Nazwa kierunku',
  POZIOM_STUDIOW: 'Poziom studiów',
  CZY_WYMAGA_FORM_ZAJEC: 'Czy przedmiot wymaga form zajęć?',
  CZY_SPAROWANO_EFEKTY: 'Czy sparowano efekty?',
  CZY_WERSJA_2019: 'Wersja 2019',
  CZY_WERSJA_2020: 'Wersja 2020',
  WERSJA: 'Wersja',
  PUNKTY_ECTS: 'Punkty ECTS',
  JEZYK_PROWADZENIA: 'Język prowadzenia',
  NAZWA_POLSKA: 'Nazwa polska',
  NAZWA_ANGIELSKA: 'Nazwa angielska',
  NAZWA_FRANCUSKA: 'Nazwa francuska',
  NAZWA_W_JEZYKU_PROWADZENIA: 'Nazwa w języku prowadzenia',
  JEDNOSTKA_PROWADZACA: 'Jednostka prowadząca',
  WYMAGANIA_WSTEPNE: 'Wymagania wstępne',
  METODY_WERYFIKACJI: 'Metody weryfikacji',
  WARUNKI_ZALICZENIA: 'Warunki zaliczenia',
  SZCZEGULOWE_TRESCI_PRZEDMIOTU: 'Szczegółowe treści przedmiotu',
  UWAGI: 'Uwagi',
  DATA_AKTUALIZACJI: 'Ostatni zapis w SID',
  JEZYK_KARTY: 'Język karty',
  SUBJECT_CARD_EMPTY_CARD_NO_VERSIONS_TITLE: 'Nie można otworzyć karty',
  SUBJECT_CARD_EMPTY_CARD_NO_VERSIONS_BODY: 'Karta nie zawiera żadnej wersji',
  FILTER_NAME_WKD: 'Wyświetlane karty przedmiotów',
  WKD_MY_SUBJECTS: 'Moje karty przedmiotów',
  WKD_WKD_SUBJECTS: 'Karty przedmiotów WKD',

  // Zakładka pojedynczego przedmiotu
  SUBJECTPAGE_TAB_STUDENTS: 'Studenci',
  SUBJECTPAGE_TAB_GROUPS: 'Grupy',
  PRZYDZIAL_LIST_CZYOCENAKONCOWAPODPISANA: 'Ocena końcowa podpisana',
  PRZYDZIAL_LIST_OCENAKONCOWA: 'Ocena końcowa',
  PRZYDZIAL_LIST_KIERUNEKID: 'Kierunek',
  PRZYDZIAL_LIST_STUDENTWYDZIAL: 'Wydział studenta',
  PRZYDZIAL_LIST_STUDENTALBUM: 'Album',
  STUDENT_OCENYCZASTKOWE: 'Oceny cząstkowe',
  PRZYDZIAL_LIST_GRUPADZIEKANSKA: 'Grupa dziekańska',

  // Zakładka karty przedmiotu
  BUTTON_COPY_DATA_FROM_OTHER_CARD: 'Kopiuj dane z innej karty',
  BUTTON_PAIR_EFFECTS: 'Paruj efekty',
  BUTTON_SAVE_CARD_IN_SID: 'Zapisz kartę w SID',
  BUTTON_SAVE_CARD_IN_SID_POPCONFIRM:
    'Czy na pewno chcesz zapisać kartę w SID? \n Karta zostanie zapisana w SID i opublikowana na stronie "programy.p.lodz.pl".',
  BUTTON_EDIT_ON: 'Włącz edycję',
  BUTTON_SAVE: 'Zapisz',
  BUTTON_PRINT_CARD: 'Drukuj kartę',
  BUTTON_GET_CARD_FROM_SID: 'Pobierz kartę z SID',

  BUTTON_GET_CARD_FROM_SID_POPCONFIRM_IN_EDIT:
    'Czy na pewno chcesz porzucić wprowadzone zmiany? \n Zmiany zostaną utracone. Zostanie pobrania najnowsza karta z SID.',
  BUTTON_GET_CARD_FROM_SID_POPCONFIRM_NOT_IN_EDIT:
    'Czy na pewno chcesz pobrać kartę z SID? \n Dane nie zostaną utracone. Karta nie znajduje się w trybie edycji.',
  BUTTON_GET_CARD_FROM_SID_SUCCESS: 'Pobranie karty z SID zakończone sukcesem',

  // domyślne tłumaczenia dla typów zakładek
  'strona-przedmiotu': 'Strona przedmiotu',
  'karta-przedmiotu': 'Karta przedmiotu',
  'strona-studenta': 'Strona studenta',

  // modal wyboru nauczyciela w celu przelogowania
  SUPERTEACHER_MODAL_SELECT_A_TEACHER: 'Wybierz nauczyciela',
  SUPERTEACHER_MODAL_LOGIN_AS: 'Logowanie jako',
  SUPERTEACHER_MODAL_LOGOUT_ERROR_TITLE: 'Błąd wylogowania',
  SUPERTEACHER_MODAL_LOGOUT_ERROR_BODY: 'Za chwilę zostaniesz całkowicie wylogowany z aplikacji',
  SUPERTEACHER_MODAL_SUBSTITUTE: 'Będziesz zastępować nauczyciela',
  SUPERTEACHER_MODAL_CONFIRM: 'Potwierdź i zaloguj',
  SUPERTEACHER_MODAL_LOG_AS_SUCCESS_TITLE: 'Zalogowano jako inny użytkownik',
  SUPERTEACHER_MODAL_LOG_AS_SUCCESS_BODY: 'Zostałeś zalogowany jako ',
  SUPERTEACHER_MODAL_LOGOUT_SUCCESS_TITLE: 'Wylogowano z konta innego użytkownika',
  SUPERTEACHER_MODAL_LOGOUT_SUCCESS_BODY: 'Zalogowano jako ',
  SUPERTEACHER_MODAL_LOGOUT_ERROR_SESSION_TEACHER_ACTIVE_TITLE: 'Nie udało się zalogować',
  SUPERTEACHER_MODAL_LOGOUT_ERROR_SESSION_TEACHER_ACTIVE_BODY: 'Wybrany nauczyciel jest aktualnie zalogowany',
  SUPERTEACHER_MODAL_RESOURCES_ACCESS_ERROR_SESSION_TEACHER_ACTIVE_TITLE: 'Zostaniesz wylogowany!',
  SUPERTEACHER_MODAL_RESOURCES_ACCESS_ERROR_SESSION_TEACHER_ACTIVE_BODY:
    'Rozpoczęła się nowa sesja nauczyciela w imieniu którego jesteś zalogowany',

  // Modal generowania raportu
  GENERATE_PROTOCOL_MODAL: 'Generowanie protokołu',
  GENERATE_PROTOCOL_MODAL_GENERATE_DATE: 'Data wygenerowania protokołu',
  PROTOCOL_GENERATION_ERROR_NO_STUDENTS_FOR_SUBJECT_TITLE: 'Nie można wygenerować protokołu',
  PROTOCOL_GENERATION_ERROR_NO_STUDENTS_FOR_SUBJECT_DESCRIPTION: 'Do protokołu nie są przypisani żadni studenci',
  PROTOCOL_GENERATION_ERROR_NO_PROTOCOL_FOR_PARAMETERS_DESCRIPTION: 'Brak protokołów dla wybranych parametrów',
  PROTOCOL_GENERATION_ERROR_USER_NOT_AUTHORIZED: 'Brak uprawnień do wygenerowania protokołu',
  PROTOCOL_GENERATION_OUT_OF_DATE_TITLE: 'Przekroczono datę generowania protokołu',
  PROTOCOL_GENERATION_OUT_OF_DATE_DESCRIPTION:
    'Brak możliwości generacji protokołu, w tym celu skontaktuj się z Supernauczycielem',
  GENERATE_PROTOCOL_MODAL_AVAILABLE_PROTOCOLS: 'Dostępne protokoły',
  GENERATE_PROTOCOL_NO_PERMISSION_TO_ANY_SUBJECT: 'Nie masz uprawnień, aby wygenerować protokół, dla wybranych przedmiotów',
  GENERATE_PROTOCOL_REMOVED_SUBJECTS_WITH_NO_PERMISSION_TITLE:
    'Protokoły zostaną wygenerowane dla przedmiotów, do których masz prawa',
  PROTOCOL_GENERATION_HAS_NOT_FINISHED_TITLE: 'Trwa generowanie protokołów',
  PROTOCOL_GENERATION_HAS_NOT_FINISHED_DESCRIPTION: 'Aktualnie trwa generowanie protokołów, spróbuj ponownie później',
  PROTOCOL_DATABASE_ERROR_TITLE: 'Błąd bazy danych',
  PROTOCOL_DATABASE_ERROR_DESCRIPTION:
    'Podczas generowania protokołu wystąpił błąd, spróbuj ponownie lub skontaktuj się z administratorem systemu',
  PROTOCOL_GENERATE_ERROR_TITLE: 'Błąd generowania protokołu',
  PROTOCOL_GENERATE_ERROR_DESCRIPTION:
    'Podczas generowania protokołu wystąpił błąd, spróbuj ponownie lub skontaktuj się z administratorem systemu',
  PROTOCOL_NOT_GENERATED_MODAL: 'Jeden lub więcej protokołów nie zostało wygenerowanych',
  PROTOCOL_NOT_GENERATED_UNKNOWN: 'Protokół nie został wygenerowany, skontaktuj się z administratorem systemu',
  PROTOCOL_NOT_GENERATED_NO_SIGN_MARKS:
    'Protokół nie został wygenerowany, ponieważ jedna lub więcej ocen końcowych jest niepodpisanych',
  PROTOCOL_NOT_GENERATED_UNKNOWN_ERROR_INFO: 'Błąd generacji',
  PROTOCOL_NOT_GENERATED_NO_SIGN_MARKS_ERROR_INFO: 'Brak podpisu',

  //Oceny
  PICK_MARK: 'Wybierz',

  // modal podpisywania ocen
  SIGN_MARKS_MODAL_TITLE: 'Podpisywanie ocen',
  SIGN_MARKS_MODAL_CONFIRM: 'Podpisz',
  SIGN_MARKS_MODAL_ARE_YOU_SURE: 'Czy na pewno chcesz anulować proces podpisywania ocen?',
  SIGN_MARKS_MODAL_MISSING_FINAL_MARK: 'Przynajmniej jeden z wybranych studentów nie posiada wystawionej oceny końcowej!',
  SIGN_MARKS_MODAL_ERROR: 'Nastąpił błąd procesu podpisywania ocen. Oceny nie zostały podpisane.',
  SIGN_MARKS_MODAL_ERROR_TITLE: 'Nastąpił błąd procesu podpisywania ocen.',
  SIGN_MARKS_MODAL_ERROR_BODY: 'Proces został anulowany, a oceny NIE zostały podpisane.',
  SIGN_MARKS_MODAL_SUCCESS_TITLE: 'Podpisano oceny!',
  SIGN_MARKS_MODAL_SUCCESS_BODY: 'Proces podpisywania ocen przebiegł prawidłowo',
  SIGN_MARKS_MODAL_REMOVED_STUDENTS_1:
    'Oceny można podpisać tylko studentom z wystawioną przez Ciebie oceną końcową. Podpisanie ocen jest możliwe dla ',
  SIGN_MARKS_MODAL_REMOVED_STUDENTS_3: 'wybranych studentów.',
  SIGN_MARKS_MODAL_NO_STUDENTS_WITH_FINAL_MARK:
    'Wybrani studenci nie mają wystawionej oceny końcowej lub nie jest ona wystawiona przez Ciebie. Brak ocen do podpisania.',
  SIGN_MARKS_MODAL_INCORRECT_VALUE: 'Pole zawiera niedozwolone znaki. Dozwolone są tylko liczby',
  SIGN_MARKS_MODAL_INCORRECT_LENGTH: 'Pole powinno zawierać 6 znaków',

  // modal sms/email
  INPUT_CODE_SMS_TITLE_MODAL: 'Wpisz kod SMS',
  INPUT_CODE_EMAIL_TITLE_MODAL: 'Wpisz kod EMAIL',
  SMS_CODE_EXPIRED_TITLE: 'Upłynął czas ważności kodu SMS',
  SMS_CODE_EXPIRED_BODY: 'Spróbuj przejść proces podpisywania ocen ponownie',

  //modal wyboru pracownika
  EMPLOYEE_CONFIRM__MODAL_TITLE: 'Wybierz pracownika dziekanatu w celu uwierzytelnienia',
  EMPLOYEE_CONFIRM__MODAL_SELECT_A_EMPLOYEE: 'Wybierz pracownika',
  EMPLOYEE_CONFIRM__MODAL_START_TYPING_PLACEHOLDER: 'Wybierz pracownika',
  SIGN_MARK_WRONG_IP_RANGE_TITLE: 'Błąd procesu podpisywania ocen!',
  SIGN_MARK_WRONG_IP_RANGE_BODY:
    'Aby podpisać ocenę musisz zarejestrować numer telefonu, na który przychodzić będą sms-y autoryzujące tę operację. Przy braku rejestracji telefonu, aby podpisać oceny udaj się do dziekanatu.',
  SIGN_MARK_INVALID_MARK_IMPORTANCE_TITLE: 'Nieprawidłowa waga formy zajęć',
  SIGN_MARK_INVALID_MARK_IMPORTANCE_BODY: 'Zgłoś do dziekanatu konieczność uzupełnienia poprawnej wagi formy zajęć',

  //modalu kodu email pracownika
  INPUT_CODE_EMAIL_EMPLOYEE_TITLE_MODAL: 'Wprowadź kod wysłany na email pracownika, którego wybrałeś w poprzednim kroku.',

  //modal z loaderem
  MARKS_SIGNING_IN_PROGRESS: 'Trwa podpisywanie ocen...',

  // Modal parowania efektów
  PAIR_EFFECTS_MODAL: 'Parowanie efektów uczenia się',
  PAIR_EFFECTS_MODAL_CHOOSE_STUDY_PROGRAM: 'Wybór programu studiów',
  PAIR_EFFECTS_MODAL_LEARNING_OUTCOMES: 'Efekty uczenia się',
  PAIR_EFFECTS_MODAL_EFFECT_DESCRIPTION: 'Opis efektu',
  PAIR_EFFECTS_MODAL_EFFECT_CODE: 'Kod efektu',
  PAIR_EFFECTS_MODAL_CHOOSE_CARD_LANG: 'Wybór języka karty',
  PAIR_EFFECTS_MODAL_CHOOSE_CARD_VERSION: 'Wybór wersji karty',
  PAIR_EFFECTS_SUCCESS_TITLE: 'Efekty kierunkowe zostały zapisane.',
  PAIR_EFFECTS_SUCCESS_DESCRIPTION: 'Aby opublikować efekty kierunkowe w SID, wciśnij przycisk "Zapisz kartę w SID".',
  PAIR_EFFECTS_MODAL_AVAILABLE_EFFECTS: 'Dostępne efekty kierunkowe',
  PAIR_EFFECTS_MODAL_EFFECTS_TO_BE_PAIRED: 'Sparowane efekty kierunkowe',
  PAIR_EFFECTS_MODAL_ITEM: 'element(y/ów)',
  PAIR_EFFECTS_MODAL_ITEMS: 'element(y/ów)',

  // modal historii zmian
  CHANGELOG_MODAL_TITLE: 'Historia zmian',
  CHANGELOG_MODAL_SEARCH: 'Wyszukaj',
  CHANGELOG_MODAL_GRADE_CHANGE: 'zmieniono na',

  // modal Realizatorzy Przedmiotu
  REALIZATORZY_MODAL_LIST: 'Wybór realizatorów przedmiotu',
  REALIZATORZY_MODAL_CHOOSE: 'Wybierz realizatorów z listy',

  //KARTA PRZEDMIOTU
  SELECT_FORM_VERSION: 'Wybierz wersję formularza',
  KP_LICZBA_PUNKTOW_ECTS: 'Liczba punktów ECTS',
  KP_NAZWA_W_JEZYKU_PROWADZENIA: 'Nazwa w języku prowadzenia',
  KP_NAZWA_PL: 'Nazwa (PL)',
  KP_NAZWA_EN: 'Nazwa (EN)',
  KP_JEZYK_ZAJEC: 'Język zajęć',
  KP_JEDNOSTKA_PROWADZACA: 'Jednostka prowadząca',
  KP_FORMY_ZAJEC_LICZBA_GODZIN: 'Formy Zajęć i Liczba Godzin',
  KP_KIEROWNIK_PRZEDMIOTU: 'Kierownik Przedmiotu',
  KP_REALIZATORZY_PRZEDMIOTU: 'Realizatorzy przedmiotu',
  KP_WYMAGANIA_WSTEPNE: 'Wymagania wstępne',
  KP_WYMAGANIA_WSTEPNE_EN: 'Wymagania wstępne (EN)',
  KP_TRESCI_PROGRAMOWE: 'Treści programowe',
  KP_TRESCI_PROGRAMOWE_EN: 'Treści programowe (EN)',
  KP_EFEKTY_UCZENIA: 'Efekty uczenia',
  KP_EFEKTY_UCZENIA_EN: 'Efekty uczenia (EN)',
  KP_METODY_WERYFIKACJI: 'Metody weryfikacji',
  KP_METODY_WERYFIKACJI_EN: 'Metody weryfikacji (EN)',
  KP_FORMY_WARUNKI_ZAL: 'Formy i warunki zaliczenia',
  KP_FORMY_WARUNKI_ZAL_EN: 'Formy i warunki zaliczenia (EN)',
  KP_SZCZEGOLOWE_TRESCI: 'Szczegółowe treści',
  KP_SZCZEGOLOWE_TRESCI_EN: 'Szczegółowe treści (EN)',
  KP_LITERATURA: 'Literatura',
  KP_LITERATURA_UZUPELNIAJACA: 'Literatura Uzupełniająca',
  KP_UWAGI_WLASNE_PUBLIKOWANE: 'Uwagi własne publikowane',
  KP_UWAGI_WLASNE_PUBLIKOWANE_EN: 'Uwagi własne publikowane (EN)',
  KP_UWAGI_WLASNE_PRYWATNE: 'Uwagi własne prywatne',
  KP_UWAGI_WLASNE_PRYWATNE_EN: 'Uwagi własne prywatne (EN)',
  KP_DATA_AKTUALIZACJI: 'Data ostatniej modyfikacji',
  KP_DATA_PUBLIKACJI: 'Data ostatniej publikacji',
  KP_DATA_OST_MODYFIKACJI: 'Data ostatniej modyfikacji',
  KP_DATA_POBRANIA_Z_SID: 'Data ostatniego pobrania z SID',
  SUBJECT_CARD_NO_AVAILABLE_VERSIONS: 'Brak dostępnych formularzy',
  SUBJECT_CARD_ARE_EFFECTS_PAIRED: 'Sparowano efekty kierunkowe',
  SUBJECT_CARD_IS_IN_EDIT: 'Karta przedmiotu jest w edycji',
  SUBJECT_CARD_IS_IN_EDIT_TOOLTIP:
    'Obecnie pracujesz na lokalnej kopii karty a informacje w niej zawarte mogą być niezgodne z kartą w SID. W celu wyjścia z trybu edycji opublikuj kartę używając przycisku "Zapisz kartę w SID" lub pobierz najnowszą kartę z SID używając przycisku "Pobierz kartę z SID"',
  UNSUPPORTED_DATA_FORMAT: 'Nieobsługiwany format danych',
  KP_KOD_PRZEDMIOTU: 'Kod przedmiotu',
  KP_CAN_NOT_SIGNING_STUDENT_MARKS: 'Zaznacz co najmniej jednego studenta, aby podpisać ocenę',
  KP_CAN_NOT_SIGNING_STUDENT_MARKS_FINAL_MARK: 'Zaznacz co najmniej jednego studenta, aby wystawić ocenę końcową',
  KP_CAN_NOT_SIGNING_NO_ACCESS: 'Brak uprawnień',
  SUBJECT_CARD_PRINT_HEADER: 'Karta przedmiotu',
  KP_FORMY_ZAJEC_EMPTY:
    'Bez wprowadzonych form zajęć karta przedmiotu jest zablokowana do edycji. Proszę zgłosić uzupełnienie form zajęć do Dziekanatu.',

  BEFORE_CHANGE: 'Przed Zmianą',
  TABLE_HEADER_DESCRIPTION: 'Opis',
  TABLE_HEADER_FIRSTNAME: 'Imię',
  TABLE_HEADER_LASTNAME: 'Nazwisko',
  HOURS_AMOUNT: 'Godz.',
  ADD_NEW_RECORD: 'Dodaj pusty wpis',
  ADD_NEW__PREDEFINED_RECORD: 'Dodaj predefiniowany wpis',
  TOTAL: 'Suma',
  FORMY_ZAJEC_NAZWA: 'Forma zajęć',
  FORMY_ZAJEC_GODZ_KONT: 'Godziny kontaktowe',
  FORMY_ZAJEC_E_LEARNING: 'Kształcenie na odległość',
  FORMY_ZAJEC_UDZIAL_WAGOWY: 'Udział wagowy form zajęć (%)',
  FORMY_ZAJEC_INFO_SUMA_WAG_ROWNA_100: 'Suma procentowa wag form zajęć musi być równa 100%',
  BILANS_OPIS: 'Opis (PL)',
  BILANS_OPIS_EN: 'Opis (EN)',
  BILANS_GODZ: 'Bilans godzin',
  PREDEFINED_TABLE_CHOOSE_VALUE: 'Wybierz wartość predefiniowaną z listy',
  KP_BILANS_GODZIN: 'Bilans Godzin',
  CANNOT_EDIT_RECORD: 'Nie można edytować rekordu',

  //modal kopiowania karty przedmiotu
  COPY_SUBJECT_CARD_MODAL_TITLE: 'Kopiowanie karty przedmiotu',
  COPY_SUBJECT_CARD_MODAL_SELECT: 'Wybierz kartę',
  COPY_SUBJECT_CARD_MODAL_SELECTED_CARD: 'Wybrana karta',
  COPY_CARD_SUCCESS_TITLE: 'Kopiowanie zakończone',
  COPY_CARD_SUCCESS_DESCRIPTION: 'Udało się skopiować kartę przedmiotu',
  COPY_CARD_POPCONFIRM_TEXT:
    'Czy na pewno chcesz skopiować dane z innej karty? \n Karta zostanie zapisana w SID i opublikowana na stronie "programy.p.lodz.pl".',

  // modal przepisywania ocen końcowych na podstawie ocen wyliczonych
  COPY_FINAL_MARKS_MODAL_TITLE: 'Przepisz studentom oceny końcowe na podstawie ocen wyliczonych',
  COPY_FINAL_MARKS_REMOVED_STUDENTS_ALERT_TITLE: 'Spośród wybranych studentów:',
  COPY_FINAL_MARKS_REMOVED_STUDENTS_ALERT_TITLE_ERROR: 'Poprawnie wystawiono {{howMuch}} z {{from}} ocen',
  COPY_FINAL_MARKS_REMOVED_STUDENTS_ALERT_DESCRIPTION_NO_CALCULATED_MARK: 'nie ma wystawionych wszystkich ocen cząstkowych',
  COPY_FINAL_MARKS_REMOVED_STUDENTS_ALERT_DESCRIPTION_MANUALLY_SIGNED_MARK: 'ma wystawioną ocenę końcową ręcznie',
  COPY_FINAL_MARKS_BY_ANOTHER:
    'ma ocenę końcową wystawioną przez innego wykładowcę, zostanie ona nadpisana a ewentualny podpis unieważniony',
  COPY_FINAL_MARKS_REMOVED_STUDENTS_ALERT_DESCRIPTION: 'Oceny końcowe zostaną przepisane studentom wymienionym poniżej:',
  COPY_FINAL_MARKS_REMOVED_STUDENTS_ALERT_DESCRIPTION_ERROR:
    'Dla wylistowanych poniżej studentów nie udało się przepisać oceny. Sprawdź poprawność danych i spróbuj ponownie lub skontaktuj się z administratorem systemu. Numer zgłoszenia: {{hash}}',

  // zapis w SID
  SAVE_IN_SID_UPDATE_CANCELLED: 'Aktualizacja karty w SID została wstrzymana',
  SUBJECT_CARD_SAVE_TO_SID_SUCCESS_TITLE: 'Publikacja karty przedmiotu zakończona sukcesem',
  SUBJECT_CARD_PUBLISH_LEARNING_EFFECTS_SUCCESS_TITLE: 'Publikacja efektów kierunkowych zakończona sukcesem',
  SUBJECT_CARDS_SAVE_SID_ERROR_NO_EFEKTY_KIERUNKOWE_TITLE: 'Brak efektów kierunkowych',
  SUBJECT_CARDS_SAVE_SID_ERROR_NO_EFEKTY_KIERUNKOWE_DESCRIPTION:
    'Proszę uzupełnić efekty kierunkowe przed publikacją karty przedmiotów.',

  CANNOT_GET_SUBJECT_INFO: 'Wystąpił problem przy pobieraniu informacji o przedmiocie',

  //proces wystawiania ocen
  UPDATE_MARK_CUSTOM_MESSAGE_TITLE: 'Nie udało się wystawić oceny',
  DATE_NOT_AVAILABLE: 'Brak daty',

  // przepisanie ocen końcowych na podstawie ocen końcowych
  COPY_FINAL_MARKS_NO_CALCULATED_MARKS_TITLE: 'Nie można przepisać końcowych ocen wybranym studentom.',
  COPY_FINAL_MARKS_NO_CALCULATED_MARKS_DESCRIPTION:
    'Wybrani studenci mają ocenę końcową wystawioną ręcznie lub nie mają wystawionych wszystkich ocen cząstkowych.',

  // zaznaczenie wszystkich rekordów na liście
  SELECT_ALL_RECORDS_IN_TABLE_INFO: 'Zaznaczono wyświetlone rekordy',
  SELECT_ALL_RECORDS_IN_TABLE_BUTTON: 'Zaznacz wszystkie',
  SELECT_ALL_SUBJECTS: 'Zaznacz wszystkie przedmioty',
  DESELECT_ALL_SUBJECTS: 'Odznacz wszystkie przedmioty',

  //klucze pól
  semestrAkademicki: 'Semestr akademicki',
  rokAkademicki: 'Rok akademicki',
  przedmiotKod: 'Kod przedmiotu',
  wydzialZlecajacyNazwa: 'Nazwa wydziału zlecającego',
  przedmiotNazwa: 'Nazwa przedmiotu',

  //błędy bazy danych
  DATABASE_ERROR_TITLE: 'Wystąpił błąd bazy danych',
  DATABASE_ERROR_BODY_1: 'Skontaktuj się z administratorem systemu',
  DATABASE_ERROR_BODY_2: 'Numer zgłoszenia: ',

  // pobieranie pliku .csv
  GET_LIST_ERROR_NO_DATA: 'Brak danych do pobrania.',

  //cache
  DATA_SYNC_IN_PROGRESS: 'Synchronizuję dane...',
  DATA_SYNC_UP_TO_DATE: 'Dane są aktualne',
  DATA_SYNC_REFRESH_PAGE: 'Odśwież stronę, aby pobrać najnowsze dane',
  DATA_SYNC_FAIL: 'Błąd synchronizacji danych',
  DATA_SYNC_FAIL_DESCRIPTION:
    'Dane, nad którymi pracujesz, mogą być nieaktualne, aplikacja dokona próby synchronizacji danych przy ponownym uruchomieniu',

  //maintenance mode
  MAINTENANCE_MODE_END_DATE: 'Planowany czas ukończenia prac',
  MAINTENANCE_MODE_PAGE_BOK_INFO: 'W sprawach pilnych skonsultuj się z Biurem Obsługi Klienta',
  MAINTENANCE_MODE_PAGE_BOK_TITLE: 'Biuro Obsługi Klienta',
  MAINTENANCE_MODE_PAGE_BOK_CONTACT: 'tel. 42 631 28 99',
  MAINTENANCE_MODE_PAGE_BOK_CONTACT_NET: '(z sieci PŁ 2899)',
  MAINTENANCE_MODE_PAGE_BOK_EMAIL: 'bok@p.lodz.pl',

  // Not Found
  NO_ACCESS_TITLE: 'Nie można pobrać informacji o zasobie.',
  NO_ACCESS_SUBTITLE: 'Dane, które próbujesz pobrać są niedostępne. Przyczyną może być: ',
  NO_ACCESS_NO_ACCESS: 'brak uprawnień do pobrania żądanych danych',
  NO_ACCESS_NOT_FOUND: 'brak zasobu w bazie danych',
  NO_ACCESS_UNKNOWN_ERROR: 'krótkoterminowy problem techniczny z pobraniem danych',

  //nowe kody błędów
  TYPICAL_ERROR_CODES_ALL_TITLE: 'Błędne żądanie',
  TYPICAL_ERROR_CODES_ALL_SUBTITLE: 'Skontaktuj się z administratorem systemu',
  WRONG_DATA_TITLE: 'Błędne dane',
  WRONG_DATA_SUBTITLE: 'Sprawdź uzupełnione dane lub skontaktuj się z administratorem systemu',

  //student finder
  SELECT_A_STUDENT: 'Wybierz studenta (aktualny semestr)',
  STUDENT_FILTER_IMIE_NAZWISKO: 'Imię i nazwisko',
  STUDENT_FILTER_ALBUM: 'Numer albumu',
  STUDENT_FILTER_WYDZIAL: 'Wydział',
  STUDENT_FILTER_KIERUNEK: 'Kierunek',
  STUDENT_FILTER_RODZAJ: 'Rodziaj studiów',
  STUDENT_FILTER_GRUPA_DZIEKANSKA: 'Grupa dziekańska',

  //info o serwerach
  ENVIRONMENT_DEVELOPMENT: 'ŚRODOWISKO DEVELOPERSKIE',
  ENVIRONMENT_STAGE: 'ŚRODOWISKO TESTOWE',

  //przejdz do panelu admina
  ADMIN_PANEL: 'Panel Administratora',

  //notification admin
  NOTIFICATION_ADMIN_TITLE: 'Informacje i komunikaty',
  NO_SHOW_AGAIN: 'Nie pokazuj ponownie',

  //opcje do zaznaczania studentów na stronie przedmiotu
  SELECT_STUDENTS_ALL: 'Zaznacz wszystkich',
  SELECT_STUDENTS_NONE: 'Odznacz wszystkich',
  SELECT_STUDENTS_WITHOUT_FINAL_MARK: 'Zaznacz studentów bez oceny końcowej',
  SELECT_STUDENTS_WITHOUT_FINAL_MARKS_AND_MINE:
    'Zaznacz studentów bez oceny końcowej oraz \n z oceną końcową wystawioną przeze mnie',
};
